import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { SchemaLink } from 'apollo-link-schema';
import { makeExecutableSchema } from 'graphql-tools';
import { getPortalToken } from '../auth';

const apiBase = process.env.REACT_APP_VERTX_API_BASE;

async function dashboardRequest(path, method = 'GET', body) {
  const token = await getPortalToken();
  const response = await fetch(`${apiBase}/dashboard-items${path}`, {
    method,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  if (!response.ok) {
    throw new Error(`Dashboard request failed (${response.status})`);
  }
  return response.json();
}

const typeDefs = `
  type DashboardItem {
    id: ID!
    layout: String
    vizState: String
    name: String
  }
  type DashboardItemConnection {
    items: [DashboardItem!]!
  }
  input CreateDashboardItemInput {
    id: ID
    layout: String
    vizState: String
    name: String
  }
  input UpdateDashboardItemInput {
    id: ID!
    layout: String
    vizState: String
    name: String
  }
  input DeleteDashboardItemInput {
    id: ID!
  }
  type Query {
    listDashboardItems: DashboardItemConnection!
    getDashboardItem(id: ID!): DashboardItem
  }
  type Mutation {
    createDashboardItem(input: CreateDashboardItemInput!): DashboardItem!
    updateDashboardItem(input: UpdateDashboardItemInput!): DashboardItem!
    deleteDashboardItem(input: DeleteDashboardItemInput!): DashboardItem!
  }
`;

const schema = makeExecutableSchema({
  typeDefs,
  resolvers: {
    Query: {
      listDashboardItems: () => dashboardRequest(''),
      getDashboardItem: (_, { id }) => dashboardRequest(`/${encodeURIComponent(id)}`),
    },
    Mutation: {
      createDashboardItem: (_, { input }) => {
        const { id, ...item } = input;
        return dashboardRequest('', 'POST', item);
      },
      updateDashboardItem: (_, { input }) => {
        const { id, ...item } = input;
        return dashboardRequest(`/${encodeURIComponent(id)}`, 'PATCH', item);
      },
      deleteDashboardItem: (_, { input }) => dashboardRequest(`/${encodeURIComponent(input.id)}`, 'DELETE'),
    },
  },
});

export default new ApolloClient({
  cache: new InMemoryCache(),
  link: new SchemaLink({ schema }),
});
